import { render, staticRenderFns } from "./modalTrasladarProducto.vue?vue&type=template&id=355b3dce&"
import script from "./modalTrasladarProducto.vue?vue&type=script&lang=js&"
export * from "./modalTrasladarProducto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports